module.exports = __webpack_public_path__ + "static/media/Region 20 Orchestra:Mariachi Solo and Ensemble Host Guidelines1.91200823.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/orchestra/Region 20 Orchestra:Mariachi Solo and Ensemble Host Guidelines1.pdf
// module id = 206
// module chunks = 0